import styles from "./main.module.scss";
import { ReactComponent as Logo } from "../../svgs/logo.svg";
import { ReactComponent as Arrow } from '../../svgs/arrow.svg';
import { useNavigate } from "react-router-dom";

const UnauthorizedPage = () => {
    const navigate = useNavigate();

  return (
    <main className={styles.layout}>
      <Logo />
      <section className={styles.container}>
        <h1 className={styles.number}>401</h1>
        <h3 className={styles.text}>Oops! You are not authorized to view this page.</h3>

         <button className={styles.link} onClick={() => navigate('/dashboard')}><span><Arrow/></span>Go to dashboard</button>
      </section>
    </main>
  );
};

export default UnauthorizedPage;
